
    <template>
    <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.01" width="16" height="16" fill="#666666"/>
    <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M13.2672 2H2.73281C2.32813 2 2 2.32813 2 2.73281V3.26719C2 3.67188 2.32813 4 2.73281 4H13.2672C13.6719 4 14 3.67188 14 3.26719V2.73281C14 2.32813 13.6719 2 13.2672 2ZM13.2672 12H2.73281C2.32813 12 2 12.3281 2 12.7328V13.2672C2 13.6719 2.32813 14 2.73281 14H13.2672C13.6719 14 14 13.6719 14 13.2672V12.7328C14 12.3281 13.6719 12 13.2672 12ZM2.73281 7H13.2672C13.6719 7 14 7.32812 14 7.73281V8.26719C14 8.67188 13.6719 9 13.2672 9H2.73281C2.32813 9 2 8.67188 2 8.26719V7.73281C2 7.32812 2.32813 7 2.73281 7Z" 
        fill="currentColor"
    />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'SingleList',
    }) as DefineComponent
    </script>
    